<template>
  <el-dialog
    id="lgaEditor"
    :title="$t('common.lgaLong')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div>
      <el-form
        ref="LGAForm"
        :model="form"
        :rules="rules"
        class="lgaForm"
        label-position="right"
        label-width="20px"
      >
        <el-form-item
          label="1."
          prop="lga1"
        >
          <el-input
            v-model="form.lga1"
            class="lgaInput"
            placeholder="Type your LGA here"
            :maxlength="255"
            @change="formatInput"
          >
            <div
              slot="suffix"
              class="suffix"
            >
              {{ lga1WordCount }}/{{ maxWordCount }}
            </div>
          </el-input>
        </el-form-item>
        <el-form-item
          label="2."
          prop="lga2"
        >
          <el-input
            v-model="form.lga2"
            class="lgaInput"
            placeholder="Type your LGA here"
            :maxlength="255"
            @change="formatInput"
          >
            <div
              slot="suffix"
              class="suffix"
            >
              {{ lga2WordCount }}/{{ maxWordCount }}
            </div>
          </el-input>
        </el-form-item>
      </el-form>

      <div class="actionWrap">
        <el-button
          round
          :disabled="processLoading"
          @click="showLocal = false"
        >
          {{ $t('common.cancel') }}
        </el-button>
        <el-button
          type="primary"
          round
          :loading="processLoading"
          @click="saveLgas"
        >
          {{ $t('common.save') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  name: 'LGAEditor',

  mixins: [dialog],

  props: {
    lga: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      processLoading: false,
      form: {
        lga1: '',
        lga2: '',
      },
      rules: {
        lga1: [
          { required: true, trigger: 'blur' },
          { validator: this.checkLength, trigger: 'change' },
        ],
        lga2: [
          { validator: this.checkLength, trigger: 'change' },
        ],
      },
      maxWordCount: 10,
      validation: false,
    };
  },

  computed: {
    lga1WordCount() {
      if (this.form.lga1 && this.form.lga1 !== '' && this.form.lga1.length) {
        return (this.form.lga1.trim()).split(' ').length;
      }
      return 0;
    },

    lga2WordCount() {
      if (this.form.lga2 && this.form.lga2 !== '' && this.form.lga2.length) {
        return (this.form.lga2.trim()).split(' ').length;
      }
      return 0;
    },
  },

  watch: {
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.init();
        }
      },
    },
  },

  methods: {
    init() {
      this.form.lga1 = this.lga.lga1;
      this.form.lga2 = this.lga.lga2;
    },

    checkLength(rule, value, callback) {
      let wordCount = 0;
      if (value && value.length > 0 && value !== '') {
        wordCount = value.trim().split(' ').length;
      }

      if (wordCount > this.maxWordCount) {
        callback(new Error(this.$t('coach.leader.lga.errorWords')));
      } else {
        callback();
      }
    },

    formatInput() {
      if (this.form.lga1) {
        this.form.lga1 = this.form.lga1.charAt(0).toUpperCase() + this.form.lga1.slice(1);
      }

      if (this.form.lga2) {
        this.form.lga2 = this.form.lga2.charAt(0).toUpperCase() + this.form.lga2.slice(1);
      }
    },

    async saveLgas() {
      try {
        this.processLoading = true;
        this.$refs.LGAForm.validate(async (vaild) => {
          if (vaild) {
            const response = await api.updateLeaderLGA(this.$route.params.id, this.form);
            this.$message.success(this.$t('coach.leader.lga.saved'));
            this.$emit('update:lga', response.data);
            this.showLocal = false;
          } else {
            this.$message.error(this.$t('coach.leader.lga.checkField'));
          }
        });
      } catch (err) {
        console.log('error submit', err);

        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.processLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #lgaEditor {
    .actionWrap {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
</style>

<style lang="scss">
  #lgaEditor {
    .lgaInput {
      .el-input__inner {
        color: black;
        padding-right: 45px;
      }
    }

    .el-form-item__label {
      &::after {
        content: '' !important;
        display: none !important;
      }
    }
  }
</style>
